import request from '@/plugins/axios';
import { decodeBase64 } from '@/common/js/utils';

// 获取内容详情
export const requestContentDetail = (id, ticket) => {
  const params = {
    content_id: id,
  };
  if (ticket) {
    params.ticket = ticket;
  }
  return request.get('/api/content/detail_v3_0', {
    params,
  });
};

// 获取内容评论v3.0
export const requestComments = (id, comment_type = 0, offset = 0, limit = 10) => request.get('/api/content/comment/get_comment_v3_0', {
  params: {
    content_id: id,
    comment_type,
    limit,
    offset
  },
}).then(res => Promise.resolve(res.data));

// 获取内容评论v3.1
// eslint-disable-next-line camelcase
export const requestComments_v3_1 = (object_type = 77, object_id, reply_limit = 3, offset = 0, limit = 10) => request.get('/api/content/comment/get_comment_v3_1', {
  params: {
    object_type,
    object_id,
    reply_limit,
    limit,
    offset
  },
}).then(res => Promise.resolve(res.data));

// 获取详情页内容推荐
// eslint-disable-next-line camelcase
export const requestDetailRecommend = (content_id, no_video = 0, offset = 0, limit = 10) => request.get('/api/content/detail_recommend', {
  params: {
    content_id,
    no_video,
    limit,
    offset,
  },
});

// 获取详情页内容推荐-test
export const requestContentRecommend = (offset = 0, limit = 10) => request.get('/api/content/recommend_content', {
  params: {
    limit,
    offset,
  },
});

// 获取推荐页列表
export const requestRecommend = (content_id = 0, is_newer = 1, limit = 10, no_video = 0) => request.get('/api/content/recommend_query', {
  params: {
    content_id,
    is_newer,
    limit,
    no_video
  },
}).then(res => Promise.resolve(res.data));

// 个人主页个人信息获取
// eslint-disable-next-line camelcase
export const requestUserInfo = user_id => request.get('/api/content/personal/info', {
  params: {
    user_id,
  },
}).then(res => Promise.resolve(res.data));

// 个人发布内容列表
// eslint-disable-next-line camelcase
export const requestUserContents = (user_id, offset = 0, limit = 10) => request.get('/api/content/personal/query_contents_v3_0', {
  params: {
    user_id,
    offset,
    limit,
  },
}).then(res => Promise.resolve(res.data));

// 分类页列表
// eslint-disable-next-line camelcase
export const requesttopicInfo = (label_id, offset = 0, limit = 10) => request.get('/api/content/content_type_v3_0', {
  params: {
    label_id,
    offset,
    limit,
  },
});

// 专题页详情
// eslint-disable-next-line camelcase
export const requestTopicDetail = topic_id => request.get('/api/content/topic/query', {
  params: {
    topic_id,
  },
});

// 专题内容列表
// eslint-disable-next-line camelcase
export const requestTopicConetnts = (topic_id, offset = 0, limit = 10) => request.get('/api/content/topic/query_content_v3_0', {
  params: {
    topic_id,
    offset,
    limit,
  },
});

// 关注列表
// eslint-disable-next-line camelcase
export const requestPersonalFollow = (user_id, offset = 0, limit = 10) => request.get('/api/content/personal/my_follow', {
  params: {
    user_id,
    offset,
    limit,
  },
}).then(res => Promise.resolve(res.data));

// 粉丝列表
// eslint-disable-next-line camelcase
export const requestPersonalFans = (user_id, offset = 0, limit = 10) => request.get('/api/content/personal/my_fans', {
  params: {
    user_id,
    offset,
    limit,
  },
}).then(res => Promise.resolve(res.data));

// 用户的个人课程列表
// eslint-disable-next-line camelcase
export const requestPersonalLesson = (user_id, offset = 0, limit = 10) => request.get('/api/content/personal/query_lesson', {
  params: {
    user_id,
    offset,
    limit,
  },
}).then(res => Promise.resolve(res.data));

// 获取验证码
export const requestVerifyCode = phone => request.get('/api/user/send_verify_code', {
  params: {
    phone,
  },
}).then(res => Promise.resolve(res));

// 验证码登录
// eslint-disable-next-line camelcase
export const verifyCodeLogin = (phone, verify_code, save_login = 1, mode = 'code-login') => request.post('/api/user/login', {
  phone,
  save_login,
  mode,
  verify_code,
}).then(res => Promise.resolve(res));

// 检验登录
export const checkLogin = () => request.get('/api/user/check_login').then(res => Promise.resolve(res));

// 获取用户信息
export const getUserSummaryForId = id => request.get('/api/user/summary', {
  params: {
    id,
  },
}).then(res => Promise.resolve(res));

// 邀请下载
export const inviteBindPhone = (phone, ticket) => request.post('/api/content/invite/bind_phone', {
  phone,
  ticket,
}).then((res) => {
  Promise.resolve(res);
});

// 国庆活动邀请下载
export const inviteActivityBindPhone = (phone, ticket) => request.post('/api/activity/20191001/invite', {
  phone,
  ticket,
}).then((res) => {
  console.log('国庆活动邀请下载', res);
  return new Promise((resolve, reject) => {
    if (res.success) resolve(res);
    else reject(res);
  });
});

// 获取分享页面
export const getWxShareOptions = scene => request.post('/api/wekuo_app/wx_share_options', {
  scene,
}).then(res => Promise.resolve(res));


// 获取分享页面
// eslint-disable-next-line camelcase
export const getDiscussDetail = discuss_id => request.get('/api/content/discuss_detail', {
  params: {
    discuss_id,
  },
}).then(res => Promise.resolve(res.data));

// 我的金币
export const getMyCoin = () => request.get('/api/content/coin/my_coin').then(res => Promise.resolve(res.data));

// 抽奖请求
export const drawCoinLottery = () => request.get('/api/content/coin_lottery/draw').then(res => Promise.resolve(res.data));

// 获取app下载链接
export const getAppLatestVersion = () => request.get('/api/wekuo_app/latest_version?platform=1002').then(res => Promise.resolve(res.data));

// 训练营详情页v4.0
// eslint-disable-next-line camelcase
export const getLessonSeriesDetail_v4_0 = (series_id, sale_link_id = 0) => request.get('/api/lesson/camp_series/detail_v4_0', {
  params: {
    series_id,
    sale_link_id
  },
}).then(res => Promise.resolve(res.data));

// 用户支付/收藏等数据
// eslint-disable-next-line camelcase
export const getUserViewData = (id, sale_link_id) => {
  const params = {
    id,
  };

  // eslint-disable-next-line camelcase
  if (sale_link_id) {
    // eslint-disable-next-line camelcase
    params.sale_link_id = sale_link_id;
  }
  return request.get('/api/lesson/series/user_view_data', {
    params,
  });
};

// 学员事迹
// eslint-disable-next-line camelcase
export const getCampDeeds = (camp_id, offset = 0, limit = 10) => request.get('/api/lesson/camp/deeds', {
  params: {
    camp_id,
    offset,
    limit,
  },
}).then(res => Promise.resolve(res.data));

// 广告获取
// eslint-disable-next-line camelcase
export const getAdv = ad_type => request.get('/api/web_ad/get_ad', {
  params: {
    ad_type,
  },
}).then(res => Promise.resolve(res.data));

// 获取视频链接new
// eslint-disable-next-line camelcase
export const getVideoUrlNew = lesson_id => new Promise((resolve, reject) => {
  request.get(`/api/lesson/video_url_new?t=${Math.floor((new Date()).getTime() / 60000)}`, {
    params: {
      id: lesson_id,
    },
  }).then((res) => {
    // 解密数据
    const buf = res.data.replace(/\n/g, '').split('');
    for (let i = 0; i < Math.floor(buf.length / 3); i++) {
      const c = buf[i * 3];
      buf[i * 3] = buf[i * 3 + 2];
      buf[i * 3 + 2] = c;
    }
    res.data = JSON.parse(decodeBase64(buf.join('')));
    resolve(res.data);
  }).catch((err) => {
    reject(err);
  });
});


// 获取视频链接
// eslint-disable-next-line camelcase
export const getVideoUrl = lesson_id => request.post(`/api/lesson/video_url?id=${lesson_id}`).then(res => Promise.resolve(res.data));

// 试看课程播放列表
// eslint-disable-next-line camelcase
export const getLessonTrySee = series_id => request.get('/api/lesson/series/lesson_try_see', {
  params: {
    series_id
  }
}).then(res => Promise.resolve(res.data));

// 获取课程详情-1
// eslint-disable-next-line camelcase
export const getDetailWithLessons = series_id => request.get('/api/lesson/series/detail_with_lessons', {
  params: {
    id: series_id
  }
}).then(res => Promise.resolve(res.data));

// 获取课程详情-2
// eslint-disable-next-line camelcase
export const getLessonSeriesDetail = series_id => request.get('/api/lesson/series/detail', {
  params: {
    id: series_id
  }
}).then(res => Promise.resolve(res.data));

// 获取系列课程的基础数据
// eslint-disable-next-line camelcase
export const getCampSeriesSummary = series_id => request.get('/api/lesson/camp_series/series_summary', {
  params: {
    series_id
  }
}).then(res => Promise.resolve(res.data));

// 收藏
// eslint-disable-next-line camelcase
export const requestUserFavorobj = (obj_id, type) => request.post('/api/user/favorobj', {
  obj_id,
  type
}).then(res => Promise.resolve(res));

// 取消收藏
// eslint-disable-next-line camelcase
export const requestUserUnfavorobj = (obj_id, type) => request.post('/api/user/favorobj', {
  obj_id,
  type
}).then(res => Promise.resolve(res));

// 获取课程有效的优惠券
// eslint-disable-next-line camelcase
export const getLessonVoucher = series_id => request.get('/api/lesson/voucher/query?valid=1', {
  params: {
    series_id
  }
}).then(res => Promise.resolve(res.data));

// 等待支付
// eslint-disable-next-line camelcase
export const waitPurchase = purchase_id => request.get('/api/lesson/wait_purchase', {
  params: { purchase_id },
}).then(res => Promise.resolve(res.data));

// 训练营学习页-课程详情
// eslint-disable-next-line camelcase
export const getCampSeriesLearnDetail_v4_0 = series_id => request.get('/api/lesson/camp_series/learn_detail_v4_0', {
  params: { series_id },
}).then(res => Promise.resolve(res.data));

// 获取入学通知书
// eslint-disable-next-line camelcase
export const getJoinCard = series_id => request.get('/api/lesson/series/join_card', {
  params: { series_id },
}).then(res => Promise.resolve(res.data));

// 训练营课程播放--学习内容、小节列表
// eslint-disable-next-line camelcase
export const getCampPlayContentDetails = content_id => request.get('/api/lesson/camp_play/content_details', {
  params: { content_id }
}).then(res => Promise.resolve(res.data));

// 训练营课程播放页-学习计划
// eslint-disable-next-line camelcase
export const getCampSeriesPlayDetail_v4_0 = series_id => request.get('/api/lesson/camp_series/play_detail_v4_0', {
  params: { series_id }
}).then(res => Promise.resolve(res.data));

// 提交课程评论
// eslint-disable-next-line camelcase
export const submitLessonComment = (labels = [], grade, content_id, advise) => {
  const params = {
    labels,
    grade,
    content_id
  };
  if (advise) {
    params.advise = advise;
  }
  return request.post('/api/feedback/submit_lesson_comment', params);
};

// 训练营播放页-课程评论标签列表
export const getLessonCommentLabels = () => request.get('/api/feedback/get_lesson_comment_labels').then(res => Promise.resolve(res.data));

// 训练营课程小节数据
// eslint-disable-next-line camelcase
export const getCampSeriesLessonInfo = lesson_id => request.get('/api/lesson/camp_series/lesson_info', {
  params: { lesson_id }
}).then(res => Promise.resolve(res.data));

// 获取用户信息
export const getUserInfo = () => request.get('/api/user/info').then(res => Promise.resolve(res.data));

// 学习报告
// eslint-disable-next-line camelcase
export const getCampSeriesStudyReport = series_id => request.get('/api/lesson/camp_series/study_report', {
  params: { series_id }
}).then(res => Promise.resolve(res.data));

// 完成学习进度
// eslint-disable-next-line camelcase
export const getStudyFinished = detail_id => request.post('/api/lesson/camp_series/study_finished', {
  detail_id
}).then((res) => {
  Promise.resolve(res);
});

// 训练营协议链接
// eslint-disable-next-line camelcase
export const serviceAgreement = series_ids => request.get('/api/lesson/series/service_agreement', {
  params: {
    series_ids
  },
}).then(res => Promise.resolve(res.data));


// 查询用户的订单详情
export const queryRefundOrders = purchase_ids => request.get('/api/ticket/query_refund_orders', {
  params: {
    purchase_ids
  },
}).then(res => Promise.resolve(res.data));

// 申请退款
export const refundApply = (purchase_ids, reason, attach) => request.post('/api/ticket/refund_apply', {
  purchase_ids, reason, attach
}).then(res => Promise.resolve(res));


// 查询用户的营期详情
export const queryPostponeSeries = series_ids => request.get('/api/ticket/query_postpone_series', {
  params: {
    series_ids
  },
}).then(res => Promise.resolve(res.data));

// 延期
export const postponeApply = (series_ids, reason, attach) => request.post('/api/ticket/postpone_apply', {
  series_ids, reason, attach
}).then(res => Promise.resolve(res));

// 查询用户的营期详情
export const queryChangeSeries = (user_id, series_ids) => request.get('/api/ticket/query_change_series', {
  params: {
    user_id,
    series_ids
  },
}).then(res => Promise.resolve(res.data));

// 申请
export const changeAccountApply = (user_id, series_ids, new_user_id) => request.post('/api/ticket/change_account_apply', {
  user_id, series_ids, new_user_id
}).then(res => Promise.resolve(res));


// 记录进入订单页
export const enterPurchaseDynamic = (series_id) => request.post(`/api/crm/customer/enter_purchase_dynamic?series_id=${series_id}`)
  .then(res => Promise.resolve(res));
